import { render, staticRenderFns } from "./HUD.vue?vue&type=template&id=0672dfc8&scoped=true&"
import script from "./HUD.vue?vue&type=script&lang=js&"
export * from "./HUD.vue?vue&type=script&lang=js&"
import style0 from "./HUD.vue?vue&type=style&index=0&id=0672dfc8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0672dfc8",
  null
  
)

component.options.__file = "HUD.vue"
export default component.exports